/**
 * Core module
 */
export * from './core.module';
